export const packagesData = [
  { tracking: "2097", guestName: "Joseph Hernandez", observations: { oversized: false, overweight: false } },
  { tracking: "9879", guestName: "Charles Hernandez", observations: { oversized: false, overweight: false } },
  { tracking: "8692", guestName: "Michael Rodriguez", observations: { oversized: false, overweight: false } },
  { tracking: "978S", guestName: "Elizabeth Johnson", observations: { oversized: false, overweight: false } },
  // ... all other entries in the same format
];
